<template>
  <div class="stat_box">
    <div class="stat_box--inner">
      <b-loading v-model="loading" :is-full-page="false"></b-loading>
      <div class="stat_box--header">
        <div>
          <h4 class="stat_box--header--label">{{ label }}</h4>
          <p class="stat_box--header--subheading" v-if="subheading">{{ subheading }}</p>
        </div>

        <div
          v-if="infoText"
          class="stat_box--header--info_tip"
        >
          <app-info-tip
            :tip="infoText"
            position="is-left"
          ></app-info-tip>
        </div>
      </div>

        <p class="stat_box--amount">{{ currentAmountFormatted }}</p>

        <p
          v-if="stat.previous_amount"
          :class="['stat_box--change', changeDirectionClass]"
        >
          <icon-default v-if="changeDirectionClass === 'negative'" icon="change-negative"/>
          <icon-default v-if="changeDirectionClass === 'positive'" icon="change-positive"/>
          {{ changedAmountFormatted }}
        </p>
    </div>
  </div>
</template>

<script>
import AppInfoTip from "../../../components/app/AppInfoTip";
import utils from "../../../services/utils";
import {ENUMS} from "../../../services/enums";

export default {
  name: "StatsBox",
  components: {
    AppInfoTip
  },
  data() {
    return {
      loading: true,
      stat: {
        type: undefined,
        current_amount: undefined,
        previous_amount: undefined,
      }
    }
  },
  props: {
    request: Function,
    label: String,
    subheading: String,
    infoText: String,
  },
  mounted() {
    this.loadStat();
  },
  computed: {
    currentAmountFormatted() {
      return this.formatByType(this.stat.current_amount)
    },
    changedAmountFormatted() {
      return this.formatByType(Math.abs(this.stat.current_amount - this.stat.previous_amount));
    },
    changeDirectionClass() {
      const changedAmount = this.stat.current_amount - this.stat.previous_amount;

      if (changedAmount === 0) return 'none';

      return (changedAmount > 0) ? 'positive' : 'negative';
    },
  },
  methods: {
    formatByType(amount) {
      // Currency
      if (this.stat.type === ENUMS.StatTypeEnum.Money.value) {
        return utils.formatCurrency(amount, 0);
      }

      // Percentage
      if (this.stat.type === ENUMS.StatTypeEnum.Percentage.value) {

        return amount.toFixed(2) + "%";
      }

      // Integer (default)
      return amount;
    },
    loadStat() {
      this.loading = true;

      return this.request().then(stat => {
        this.stat = stat.data;
        this.loading = false;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.stat_box {
  position: relative;
}

.stat_box--inner {
  height: 100%;
  min-height: 80px;
  padding: 10px 10px 4px;
  border: 1px solid $border;
}

.stat_box--header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  &--label {
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: bold;
    color: $text-muted;
  }

  &--subheading {
    font-size: 16px;
    color: $text-muted;
  }
}

.stat_box--amount {
  font-size: 40px;
}

.stat_box--change {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 6px;
  font-size: 14px;

  &.positive {
    color: $success;
  }

  &.negative {
    color: $danger;
  }
}

</style>
